var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.67 491.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "cls-1",
    d: "m166.83,0C74.84,0,0,74.84,0,166.83c0,36.97,21.76,93.19,68.49,176.93,31.89,57.14,63.63,105.4,64.97,107.43l22.94,34.77c2.31,3.51,6.23,5.62,10.43,5.62s8.12-2.11,10.43-5.62l22.94-34.77c1.33-2.01,32.84-49.85,64.97-107.43,46.73-83.74,68.49-139.95,68.49-176.93C333.67,74.84,258.83,0,166.83,0Zm76.51,331.58c-31.69,56.78-62.7,103.87-64,105.85l-12.51,18.96-12.5-18.95c-1.31-2-32.56-49.51-64.01-105.85C46.98,253.9,25,198.47,25,166.83c0-78.21,63.63-141.83,141.83-141.83s141.83,63.63,141.83,141.83c0,31.64-21.98,87.07-65.32,164.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "cls-1",
    d: "m166.83,73.29c-51,0-92.5,41.5-92.5,92.5s41.5,92.5,92.5,92.5,92.5-41.5,92.5-92.5-41.5-92.5-92.5-92.5Zm0,160c-37.22,0-67.5-30.28-67.5-67.5s30.28-67.5,67.5-67.5,67.5,30.28,67.5,67.5-30.28,67.5-67.5,67.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.8e6a5833f5c665565c2e0605e637f3f3.svg";
export { ForwardRef as ReactComponent };